// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020931/js/" + chunkId + "." + {"44":"7fd6cc3d","225":"bd2fa8e3","481":"0cf740eb","486":"3dd4e610","770":"0dbefdad"}[chunkId] + ".0.29462788848944566.chunk.js";
};